import createAxiosInstance from '../../../../api';
import { useDispatch } from 'react-redux';
import { useAlert } from '../../../../components/Notification';
import {
  setAllUserListAction,
  setUserListAction,
} from '../../../../stores/actionTypes/userActions';
export function useHook() {
  const axiosInstance = createAxiosInstance();
  const dispatch = useDispatch();
  const showAlert = useAlert();

  const fetchUserList = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/listUser', payload)
      .then((response) => {
        dispatch(setUserListAction(response?.data?.data));
        data = response.data;
      })
      .catch(() => {
        dispatch(setUserListAction([]));
        showAlert('Failed get List User', 'warning');
      });
    return data;
  };
  const fetchAllUserList = async (payload) => {
    await axiosInstance
      .post('/listUser', payload)
      .then((response) => {
        dispatch(setAllUserListAction(response?.data?.data));
      })
      .catch(() => {
        dispatch(setAllUserListAction([]));
        showAlert('Failed get List User', 'warning');
      });
  };

  const fetchUserDetails = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/getUserDetails', payload)
      .then((response) => {
        data = response?.data?.data;
      })
      .catch(() => {
        showAlert('Failed get User Details', 'warning');
      });
    return data;
  };
  return {
    fetchUserList,
    fetchAllUserList,
    fetchUserDetails,
  };
}
